/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */
import { IUser } from "@/common/api/services/types";
import { useUserStore } from "@/common/store/userStore";

export interface CurrentUserObject extends IUser {}

export class CurrentUserObject {
  readonly CONTENT_MANAGER_ROLE = "content manager";

  constructor(src: IUser) {
    Object.assign(this, src, {});
  }

  getRoles(): string[] {
    return this.roles ?? [];
  }

  hasRole(role: string): boolean {
    if (!this.roles) {
      return false;
    }

    return this.roles.indexOf(role) >= 0;
  }

  isContentManager(): boolean {
    return this.hasRole(this.CONTENT_MANAGER_ROLE);
  }
}

export const useVisitorInfo = (): CurrentUserObject | null => {
  const currentUser = useUserStore((state) => state.currentUser);

  if (!currentUser) {
    return null;
  }

  return new CurrentUserObject(currentUser);
};
